import React from "react";
//import styles from "./styles/sidenav.module.css";
import "./formInput.css";
const ErrorText = (props) => {
  return <span className="error_span">{props.children}</span>;
};

export default ErrorText;
